export default "__VITE_ASSET__M8P9C0qe__"